import React from 'react'
import { Link } from 'react-router-dom'

import {
  Assignment,
  Cookie,
  Copyright,
  Email,
  KeyboardArrowUp,
  PrivacyTip,
} from '@mui/icons-material'
import {
  Box,
  Button,
  Container,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material'

import { routeNames } from '~/constants/uiRouteNames'

import DarkModeToggle from './DarkModeToggle'
import L from './Helpers/Lang'

export const contactItems = [
  {
    id: 'email',
    label: 'shop@skybrush.io',
    icon: <Email />,
    url: 'mailto:shop@skybrush.io',
  },
  // {
  //   id: 'discord',
  //   label: 'Skybrush Community',
  //   icon: <Discord />, // import Discord from './Icons/Discord'
  //   url: 'https://skybrush.io/r/discord',
  // },
  // {
  //   id: 'address',
  //   label: 'Lövőház utca 28, H-1024 Budapest, Hungary, EU',
  //   icon: <Place />, // import { Place } from '@mui/icons-material'
  //   url: 'https://www.google.com/maps/search/Lövőház utca 28, H-1024 Budapest, Hungary, EU',
  // },
]

export const legalItems = [
  {
    id: 'privacy-policy',
    label: <L term="nav.privacy-policy" />,
    icon: <PrivacyTip />,
    url: routeNames.privacyPolicy,
  },
  {
    id: 'cookie-policy',
    label: <L term="nav.cookie-policy" />,
    icon: <Cookie />,
    url: routeNames.cookiePolicy,
  },
  {
    id: 'terms-of-sale',
    label: <L term="nav.terms-of-sale" />,
    icon: <Assignment />,
    url: routeNames.termsOfSale,
  },
]

const Footer = () => {
  const [contactAnchorEl, setContactAnchorEl] = React.useState(null)
  const [legalAnchorEl, setLegalAnchorEl] = React.useState(null)

  return (
    <Box
      component="footer"
      sx={{
        display: { xs: 'none', sm: 'block' },
        width: '100%',
        position: 'relative',
      }}
    >
      <Box
        sx={(theme) => ({
          position: 'absolute',
          top: 0,
          left: 0,

          width: '100%',
          height: '100%',

          background: theme.palette.action.selected,
          zIndex: -1,
        })}
      />
      <Container
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: 2,

          '@media(max-width: 720px)': {
            p: 1,
            gap: 1,
          },

          height: 64,
          [`${theme.breakpoints.down('lg')} and (orientation: landscape)`]: {
            height: 56,
          },
          [theme.breakpoints.down('md')]: { height: 48 },
        })}
      >
        <Button
          color="inherit"
          onClick={(event) => setContactAnchorEl(event.currentTarget)}
          startIcon={
            <KeyboardArrowUp
              sx={{
                rotate: Boolean(contactAnchorEl) ? '180deg' : '0deg',
                transition: 'rotate 0.5s',
              }}
            />
          }
        >
          Contact
        </Button>
        <Menu
          anchorEl={contactAnchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          open={Boolean(contactAnchorEl)}
          onClose={() => setContactAnchorEl(null)}
          marginThreshold={0}
        >
          {contactItems.map(({ id, label, icon, url }) => (
            <MenuItem
              key={id}
              component={Link}
              to={url}
              onClick={() => setContactAnchorEl(null)}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              {label}
            </MenuItem>
          ))}
        </Menu>

        <Button
          color="inherit"
          onClick={(event) => setLegalAnchorEl(event.currentTarget)}
          startIcon={
            <KeyboardArrowUp
              sx={{
                rotate: Boolean(legalAnchorEl) ? '180deg' : '0deg',
                transition: 'rotate 0.5s',
              }}
            />
          }
        >
          Legal
        </Button>
        <Menu
          anchorEl={legalAnchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          open={Boolean(legalAnchorEl)}
          onClose={() => setLegalAnchorEl(null)}
          marginThreshold={0}
        >
          {legalItems.map(({ id, label, icon, url }) => (
            <MenuItem
              key={id}
              component={Link}
              to={url}
              onClick={() => setLegalAnchorEl(null)}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              {label}
            </MenuItem>
          ))}
        </Menu>

        <Typography variant="subtitle1" color="text.secondary">
          <Copyright fontSize="small" sx={{ verticalAlign: 'text-bottom' }} />{' '}
          {new Date().getFullYear()} CollMot Robotics.
        </Typography>

        <Box flex={1} mx={-1} />

        <DarkModeToggle style={{ marginBottom: '-8px' }} />
      </Container>
    </Box>
  )
}

export default Footer
